<template>
    <div>
        <div>
            <div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
                整体调薪-{{ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改'}}</div>
            <el-button
                style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                @click="Return">返回</el-button>

            <!-- 主体 -->
            <div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
                <!-- 查询框 -->
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
                    <el-row>
                        <el-col :span="12">
                            <div @click="txbm()">
                                <el-form-item label="调薪部门" prop="project_name" style="margin-top:80px;width:80%">
                                    <el-input style="width:595px" v-model="ruleForm.project_name"
                                        onfocus="this.blur();"></el-input>
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="调薪人员" prop="change_staff_name" style="width:80%">
                                <el-input v-model="ruleForm.change_staff_name" :disabled="true" style="width:595px">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="调薪时间" prop="change_date">
                                <el-date-picker v-model="ruleForm.change_date" style="width:595px" type="date"
                                    placeholder="请选择" value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="调薪类型" prop="dictionaries_id" style="width:80%">
                                <el-select v-model="ruleForm.dictionaries_id" style="width:595px" placeholder="请选择"
                                    clearable>
                                    <el-option v-for="item in $parent.postList" :key="item.id" :label="item.data"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="金额" prop="change_money" style="width:80%">
                                <el-input type="number" v-model="ruleForm.change_money" style="width:595px">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="调薪原因" prop="change_reason">
                                <el-input type="textarea" :rows="2" style="width:595px" placeholder="请输入调薪原因"
                                    v-model="ruleForm.change_reason">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="12">
                            <el-form-item style="width: 100%; text-align: center;" label-width="0">
                                <el-button type="goon" @click="AddAuditor()"
                                    v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
                                <el-button type="goon" @click="UpdateAuditor()"
                                    v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
                                <el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

            </div>

        </div>
        <el-dialog title="调薪部门" :visible.sync="dialogVisible" width="40%" :center="true" :close-on-click-modal="false"
            :show-close="false">
            <el-row>
                <organizeStaff ref="organizeStaff" type="checkbox" :accordion="true"
                    @commit="saveChange"
                    :staff_ids_prop="object.staff_ids"></organizeStaff>
            </el-row>
            <el-row style="text-align: center;">
                <el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
            </el-row>
        </el-dialog>

        <!-- <el-dialog title="选择审核人" :visible.sync="dialogAuditorVisible" width="40%" :center="true"
            :close-on-click-modal="false">
            <SelectAuditor ref="SelectAuditor" :type="7" :examineDetailsList="ruleForm.examineDetailsList"
                :id="ruleForm.id"></SelectAuditor>
        </el-dialog> -->
    </div>
</template>

<script>
    import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
    // import SelectAuditor from '../SelectAuditor/SelectAuditor.vue';
    export default {
        components: {
            organizeStaff: organizeStaff,
            // SelectAuditor: SelectAuditor,
        },
        props: ["organizeList"],
        data() {
            return {
                //表单数据
                ruleForm: {
                    id: '',
                    project_id: '',
                    project_name: '',
                    change_staff: '',
                    change_staff_name: '',
                    change_date: '',
                    dictionaries_id: '',
                    change_money: '',
                    change_reason: '',
                    examineDetailsList: [],
                },

                //暂存数据
                object: {
                    staff_ids: [],
                    staff_name: "",
                    project_id: "",
                    project_name: ""
                },

                //表单验证
                rules: {
                    project_name: [{
                        required: true,
                        message: '请选择调薪部门和人员！',
                        trigger: 'blur'
                    }],
                    change_date: [{
                        required: true,
                        message: '请选择调薪时间！',
                        trigger: 'blur'
                    }],
                    dictionaries_id: [{
                        required: true,
                        message: '请选择调薪类型！',
                        trigger: 'blur'
                    }],
                    change_money: [{
                        required: true,
                        message: '请输入调薪金额！',
                        trigger: 'blur'
                    }],
					change_reason: [{
                        required: true,
                        message: '请输入调薪原因！',
                        trigger: 'blur'
                    }],
                },

                //页面相关
                dialogVisible: false,
                dialogAuditorVisible: false
            };
        },
        methods: {
            txbm() {
                this.dialogVisible = true;
                this.showtxbm = true;
            },
            //设置确定
            saveChange(e) {
                var change_staff = "";
                e.staff_ids.forEach(item => {
                    change_staff += item + ",";
                })

                this.ruleForm.change_staff = change_staff;
                this.ruleForm.change_staff_name = e.staff_name;
                this.ruleForm.project_id = e.organize_id;
                this.ruleForm.project_name = e.organize_name;
                this.dialogVisible = false;
            },
            //添加
            // AddAuditor() {
            //     this.$refs["ruleForm"].validate((valid) => {
            //         if (valid) {
            //             this.ruleForm.examineDetailsList = [];
            //             this.dialogAuditorVisible = true;
            //             this.$refs['SelectAuditor'].initialize();
            //         } else {
            //             console.log('error submit!!');
            //             return false;
            //         }
            //     });
            // },
            AddAuditor() {
				this.$refs["ruleForm"].validate((valid) => {
					if (valid) {
						this.Add()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
            async Add() {
                var url = 'changeSalary/add';
                var record = {
                    project_id: this.ruleForm.project_id,
                    change_staff: this.ruleForm.change_staff,
                    change_date: this.ruleForm.change_date,
                    dictionaries_id: this.ruleForm.dictionaries_id,
                    change_money: this.ruleForm.change_money,
                    change_reason: this.ruleForm.change_reason,
                    examineDetailsList: this.ruleForm.examineDetailsList,
                    applicant_id: this.$globals.user.staff_id,
                };
                var data = await this.$globals.AxiosPost(url, record);
                debugger
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.Return();
                    } else {
                        this.$message.warning(data);
                    }
                }
                
            },
            //修改
            // UpdateAuditor() {
            //     this.$refs["ruleForm"].validate((valid) => {
            //         if (valid) {
            //             this.ruleForm.examineDetailsList = [];
            //             this.dialogAuditorVisible = true;
            //             this.$refs['SelectAuditor'].initialize();
            //         } else {
            //             console.log('error submit!!');
            //             return false;
            //         }
            //     });
            // },
            async UpdateAuditor() {
                var url = 'changeSalary/modify';
                var record = {
                    id: this.ruleForm.id,
                    project_id: this.ruleForm.project_id,
                    change_staff: this.ruleForm.change_staff,
                    change_date: this.ruleForm.change_date,
                    dictionaries_id: this.ruleForm.dictionaries_id,
                    change_money: this.ruleForm.change_money,
                    change_reason: this.ruleForm.change_reason,
                    examineDetailsList: this.ruleForm.examineDetailsList,
                    applicant_id: this.$globals.user.staff_id,
                };
                var data = await this.$globals.AxiosPost(url, record);
                if (data === '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code === '200') {
                        this.$message.success(data);
                        this.Return();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            Return() {
                this.dialogAuditorVisible = false;
                this.$parent.Return();
                this.$refs["ruleForm"].resetFields();
            },
        },
        created() {
            this.ruleForm = this.$parent.ruleForm;
        },
        watch: {
            "ruleForm.change_staff"(newValue) {
                this.object.staff_ids = [];
                newValue.split(",").forEach(item => {
                    if (item != '' && item != null) {
                        this.object.staff_ids.push(parseInt(item));
                    }
                })
            },
            "ruleForm.change_staff_name"(newValue) {
                this.object.staff_name = newValue;
            },
            "ruleForm.project_id"(newValue) {
                this.object.project_id = newValue;
            },
            "ruleForm.project_name"(newValue) {
                this.object.project_name = newValue;
            },
        },
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Zttx_add.vue?ff36c15c